import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import '../styles/ProductForm.css';

const EditProductForm = ({ product, onProductUpdated, onCancel, isSeller }) => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    prod_code: '',
    prod_name: '',
    prod_description: '',
    prod_price: '',
    prod_stock: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (product) {
      setFormData({
        prod_code: product.prod_code || '',
        prod_name: product.prod_name || '',
        prod_description: product.prod_description || '',
        prod_price: product.prod_price ? product.prod_price.toString() : '',
        prod_stock: product.prod_stock !== undefined ? product.prod_stock.toString() : ''
      });
    }
  }, [product]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        setError('No se encontró un token de autenticación. Por favor, inicie sesión nuevamente.');
        return;
      }

      // Validar campos requeridos
      if (!formData.prod_name || !formData.prod_price) {
        setError('El nombre y el precio son obligatorios');
        setLoading(false);
        return;
      }

      // Convertir precio a número
      const productData = {
        ...formData,
        prod_price: parseFloat(formData.prod_price),
        prod_stock: formData.prod_stock ? parseInt(formData.prod_stock) : 0
      };

      // Usar endpoint diferente según el rol del usuario
      let endpoint;
      if (isSeller) {
        endpoint = `/api/products/seller/${product.id}`;
      } else if (user?.role === 'manager') {
        endpoint = `/api/supervisors/products/${product.id}`;
      } else {
        endpoint = `/api/products/${product.id}`;
      }

      console.log('EditProductForm: User role:', user?.role);
      console.log('EditProductForm: Using endpoint:', endpoint);

      await axios.put(endpoint, productData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      // Notificar al componente padre
      onProductUpdated();
    } catch (error) {
      console.error('Error al actualizar producto:', error);
      setError(error.response?.data?.message || 'Error al actualizar el producto. Por favor, inténtelo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="product-form-container">
      <h3>Editar Producto</h3>
      {error && <div className="error-message">{error}</div>}
      <form className="product-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="prod_code">Código de Barras</label>
          <input
            type="text"
            id="prod_code"
            name="prod_code"
            value={formData.prod_code}
            onChange={handleChange}
            placeholder="Código o clave del producto"
          />
        </div>
        <div className="form-group">
          <label htmlFor="prod_name">Nombre del Producto *</label>
          <input
            type="text"
            id="prod_name"
            name="prod_name"
            value={formData.prod_name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="prod_description">Descripción</label>
          <textarea
            id="prod_description"
            name="prod_description"
            rows="3"
            value={formData.prod_description}
            onChange={handleChange}
          ></textarea>
        </div>
        <div className="form-group">
          <label htmlFor="prod_price">Precio *</label>
          <input
            type="number"
            id="prod_price"
            name="prod_price"
            step="0.01"
            min="0"
            value={formData.prod_price}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="prod_stock">Stock</label>
          <input
            type="number"
            id="prod_stock"
            name="prod_stock"
            min="0"
            value={formData.prod_stock}
            onChange={handleChange}
          />
        </div>
        <div className="form-buttons">
          <button type="button" className="cancel-btn" onClick={onCancel} disabled={loading}>
            Cancelar
          </button>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Guardando...' : 'Guardar Cambios'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditProductForm;
